export enum ApiType {
  GZ_CONSOLE_API = 'gzConsoleApi',
  GZ_INTERNAL_API = 'gzInternalApi',
  NIRVANA_INTERNAL_API = 'nirvanaInternalApi',
  ENDPOINTS_API = 'endpointsApi',
}
